import {withPlatform} from '@lib/PlatformedRegistry';
import {LayoutPage as desktop} from './LayoutPage@desktop';
export var LayoutPage = withPlatform({
  desktop: desktop
});
